/**
 * Internal RPC DTOs for the v2 scheduler ↔ worker contract.
 *
 * NOT USED in the MVP single-process deploy — the scheduler app doesn't exist
 * yet. Kept in contracts so the apps/server's lease module can be extracted
 * to apps/scheduler in v2 with zero schema change. See architecture-mvp.md
 * §20 "MVP → v2 演进路径".
 */
import { z } from 'zod';
export const LeaseAcquireRequest = z.object({
    podName: z.string(),
    capacity: z.number().int().min(1).max(200),
    affinity: z
        .object({
        tenantIds: z.array(z.string().uuid()).optional(),
    })
        .optional(),
});
export const LeaseAssignment = z.object({
    accountId: z.string().uuid(),
    fencingToken: z.number().int(),
    sessionEncrypted: z.string(),
    proxy: z.object({
        endpoint: z.string(),
        credentialsEncrypted: z.string(),
    }),
});
export const LeaseAcquireResponse = z.object({
    podName: z.string(),
    leaseExpiresAt: z.string().datetime(),
    assignments: z.array(LeaseAssignment),
});
export const LeaseRenewRequest = z.object({
    podName: z.string(),
    tokens: z.record(z.string(), z.number().int()), // accountId -> fencingToken
});
export const LeaseRenewResponse = z.object({
    leaseExpiresAt: z.string().datetime(),
    rejected: z.array(z.string().uuid()),
});
//# sourceMappingURL=lease.js.map